export const TOGGLE_LOAD = "TOGGLE_LOAD"
export const GET_RECIPES = 'GET_RECIPES'
export const GET_JOBS = 'GET_JOBS'
export const JOB_FETCH_ERROR = "JOB_FETCH_ERROR"
export const INIT_ALL_VALUES = 'INIT_ALL_VALUES'
export const JOB_SEARCH = "JOB_SEARCH"
export const GLOBAL_SEARCH = "GLOBAL_SEARCH"
export const UPDATE_FILTERS = "UPDATE_FILTERS"
export const INCREMENT_PAGE = "INCREMENT_PAGE"
export const GET_FOOTER_DATA = "GET_FOOTER_DATA"
export const UPDATE_SORT_OPTION = "UPDATE_SORT_OPTION"
export const UPDATE_CLAFE_FILTER = "UPDATE_CLAFE_FILTER"
export const REMOVE_CLAFE_FILTER = "REMOVE_CLAFE_FILTER"
export const UPDATE_SEARCH_TERM = "UPDATE_SEARCH_TERM"
export const RESET_LIST_CONTROLS = "RESET_LIST_CONTROLS"
export const RECIPE_FETCH_ERROR = "RECIPE_FETCH_ERROR"